import React from "react";
import { NotifierNumber } from "./notifier-number.styles";

export default function Notifier(props) {
  return (
    <NotifierNumber isSmall={props.isSmall}>{props.number}</NotifierNumber>
  );
}
